import React, {useEffect} from 'react'
import {makeStyles} from '@material-ui/core'
import ProductsOrderStyle from 'pages/ProductHistory/PurchaseHistoryList/style'
import CardWithTitle from 'components/atoms/CardWithTitle'
import {useTranslation} from 'react-i18next'
import TableToolbar from 'pages/ProductHistory/PurchaseHistoryList/TableToolbar'
import DataTable from 'pages/ProductHistory/PurchaseHistoryList/DataTable'
import useProductManagement from 'features/productManagement/useProductManagement'
import {navigate} from 'AppHistory'
import {TYPE_INDICATOR_PRODUCT} from 'pages/ProductsPages/constant'

const useStyles = makeStyles(ProductsOrderStyle)
const PurchaseHistoryList = () => {
  const classes = useStyles()
  const {t} = useTranslation()
  const {getPackageList} = useProductManagement()

  const {listProductPurchaseHistory} = useProductManagement()
  useEffect(() => {
    getPackageList({
      target: TYPE_INDICATOR_PRODUCT.ALL,
    })
  }, [])
  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: 4,
      }}
    >
      <CardWithTitle className={classes.cardContainer}>
        <TableToolbar />
        {listProductPurchaseHistory && listProductPurchaseHistory.length > 0 ? (
          <DataTable
            listProductPurchaseHistory={listProductPurchaseHistory}
            onClickPurchaseDetail={(paymentId) => {
              navigate(
                `/products-purchase-history/purchase-detail/${paymentId}`,
              )
            }}
          />
        ) : (
          <div>{t('INoPurchaseHistory')}</div>
        )}
      </CardWithTitle>
    </div>
  )
}

export default PurchaseHistoryList
